function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(134 -47.207)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-104,69.363l-5.648-20.342-4.868,1.352.538,1.937h-5.415v-2.7h-5.052v2h-2.736v-4.4H-134V70.723h20.945V55.634l4.187,15.08ZM-123.477,50.58h3.115v2.4h-3.115Zm0,6.416h3.115V68.011h-3.115Zm0-.969v-.556h3.115v.556Zm0-1.524v-.556h3.115V54.5Zm-4.673,13.366h-4.881V50.048h4.881Zm0-19.694v.9h-4.881v-.9Zm-4.881,21.579v-.916h4.881v.916Zm8.586,0h-2.736V52.577h2.736Zm.969,0V68.98h3.115v.774Zm9.453,0h-5.369V53.278h5.369Zm5.83-.232L-111.6,57.255l3-.833,3.406,12.266Zm-3.665-13.2-.267-.961,3-.833.267.961Zm1.537-6.109.939,3.381-3,.833-.939-3.381Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.12,
  height: 0.969,
  transform: "translate(-118.268 54.326)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.12,
  height: 0.969,
  transform: "translate(-118.268 56.028)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.12,
  height: 0.969,
  transform: "translate(-118.268 57.73)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.12,
  height: 0.969,
  transform: "translate(-118.268 67.586)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 0.969,
  height: 1.631,
  transform: "translate(-126.298 61.547)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 0.969,
  height: 3.687,
  transform: "translate(-126.298 64.099)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 0.969,
  height: 4.396,
  transform: "translate(-126.298 56.229)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 0.969,
  height: 1.702,
  transform: "translate(-126.298 53.676)",
  fill: "#fff"
}));

var SvgLibrary = function SvgLibrary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "library",
    className: "fill",
    width: 30,
    height: 23.516,
    viewBox: "0 0 30 23.516",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLibrary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/library.46e8ad36.svg";
export { ForwardRef as ReactComponent };